import { useCallback } from 'react'
import { useOnboardingContext } from './OnboardingContext'

export const useGoBack = () => {
  const { step, setStep } = useOnboardingContext()
  return useCallback(() => {
    setStep(step - 1)
  }, [setStep, step])
}
